/* The 1-2-1 Mentorship (ClientSpace.dc.html at 1440, both Tweaks), in Adam's master brand: white,
   near-black for text and buttons, greys as tints of it, gold only for small accents that never carry
   text. Colours are the tokens file's. Small text never uses a grey lighter than --shell-ink-60 (the
   board's 55% labels and 45% ticked actions measure under 4.5 to 1, so they use it here).
   At phone width (no board) the rows stack and the boxes take the whole width, as PhoneLibrary and
   PhoneWeek do. */

/* The page sits 40px under the menu, as the board's main does */
.pp .pp-area:has(> .ms) { --pp-area-top: 40px; }
.ms { display: flex; flex-direction: column; gap: 26px; min-width: 0; color: var(--shell-ink); }
.ms--loading { min-height: 60vh; }
.ms button { font-family: inherit; cursor: pointer; }
.ms button[disabled] { cursor: default; }
.ms input, .ms textarea, .ms select { font-family: inherit; color: var(--shell-ink); }
.ms input::placeholder, .ms textarea::placeholder { color: var(--shell-ink-60); }

/* Adam's bar, the full width of the page under the menu */
.ms-bar {
  display: flex; align-items: center; justify-content: space-between; gap: 20px;
  margin: -40px calc(-1 * var(--pp-gutter)) 14px; padding: 14px var(--pp-gutter);
  background: var(--shell-ink); color: var(--shell-on-ink);
}
.ms-bar-text { display: flex; align-items: center; gap: 10px; font-size: 14px; font-weight: 600; line-height: 1.45; }
.ms-bar-dot { width: 8px; height: 8px; border-radius: 4px; background: var(--shell-gold); flex-shrink: 0; }
.pp .ms-bar-link { color: var(--shell-on-ink); font-size: 14px; font-weight: 700; flex-shrink: 0; }

/* The head */
.ms-head { display: flex; flex-direction: column; gap: 8px; }
.ms-eyebrow { font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); font-weight: 700; }
.ms-h1 { margin: 0; font-size: 40px; font-weight: 800; letter-spacing: -0.01em; line-height: normal; }
.ms-empty { margin: 0; font-size: 16px; line-height: 1.6; color: var(--shell-ink-66); }

/* 2 cards side by side: the next session and Book a session; the files and Ask Adam */
.ms-row { display: grid; grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr); gap: 22px; }
.ms-row--files { align-items: start; }
.ms-row--single { grid-template-columns: minmax(0, 1fr); }

/* The buttons */
.ms-btn {
  align-self: flex-start; height: 44px; padding: 0 18px; border-radius: 10px; border: none;
  background: var(--shell-ink); font-weight: 700; font-size: 14px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none; white-space: nowrap;
}
.pp .ms-btn { color: var(--shell-on-ink); }
.ms-btn--small { height: 40px; padding: 0 16px; border-radius: 8px; font-size: 13px; }
.ms-btn--watch { height: 38px; padding: 0 16px; border-radius: 9px; font-size: 14px; }
.ms-btn[disabled] { opacity: 0.6; }
.ms-btn-line {
  height: 38px; padding: 0 16px; border-radius: 9px; border: 1px solid var(--shell-ink-20); background: var(--shell-bg);
  color: var(--shell-ink); font-weight: 700; font-size: 14px; white-space: nowrap;
}
.ms-btn-line--small { height: 36px; padding: 0 14px; border-radius: 8px; font-size: 13px; align-self: flex-start; }
.ms-btn-line[disabled] { opacity: 0.6; }

/* The next session */
.ms-next {
  padding: 28px; border-radius: 16px; background: var(--shell-ink); color: var(--on-dark);
  display: flex; flex-direction: column; gap: 14px; min-width: 0;
}
.ms-next-label { font-size: 12px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--on-dark-70); }
.ms-next-when { font-size: 32px; font-weight: 800; letter-spacing: -0.01em; line-height: normal; }
.ms-next-line { font-size: 15px; color: var(--on-dark-80); }
.ms-next-actions { display: flex; gap: 10px; margin-top: 4px; flex-wrap: wrap; }
.ms-chip {
  height: 42px; padding: 0 16px; border-radius: 10px; background: var(--on-dark-12); font-size: 14px; font-weight: 700;
  display: flex; align-items: center;
}
.ms-cal {
  height: 42px; padding: 0 16px; border-radius: 10px; border: 1px solid var(--on-dark-45); background: transparent;
  color: var(--on-dark); font-weight: 700; font-size: 14px;
}
.ms-join {
  height: 42px; padding: 0 20px; border-radius: 10px; background: var(--on-dark); font-weight: 700; font-size: 14px;
  display: inline-flex; align-items: center; text-decoration: none;
}
.pp .ms-join { color: var(--shell-ink); }

/* Book a session */
.ms-book {
  padding: 28px; border-radius: 16px; border: 1px solid var(--shell-ink-10);
  display: flex; flex-direction: column; gap: 12px; min-width: 0;
}
.ms-card-label { font-size: 12px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--shell-ink-60); }
.ms-book-line { font-size: 16px; line-height: 1.55; color: var(--shell-ink-75); }
.ms-book-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }

/* Adam's boxes: a dashed line above, as "Booking link, Adam only" */
.ms-box { display: flex; flex-direction: column; gap: 8px; padding-top: 10px; border-top: 1px dashed var(--shell-ink-20); }
.ms-box-label { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.ms-box-label--field { display: flex; flex-direction: column; gap: 6px; }
.ms-box input, .ms-box select {
  height: 38px; padding: 0 10px; border-radius: 8px; border: 1px solid var(--shell-ink-20); background: var(--shell-bg);
  font-size: 13px; font-weight: 500; letter-spacing: 0; text-transform: none; min-width: 0; width: 100%;
}
.ms-box-msg { font-size: 13px; line-height: 1.5; color: var(--shell-ink-66); }
.ms-box--dark { border-top-color: var(--on-dark-28); margin-top: 4px; gap: 10px; }
.ms-box--dark .ms-box-label { color: var(--on-dark-70); }
.ms-box--dark .ms-box-msg { color: var(--on-dark-80); }
.ms-next-fields { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
.ms-field { display: flex; flex-direction: column; gap: 6px; font-size: 12px; font-weight: 700; color: var(--on-dark-80); min-width: 0; }
.ms-field--wide { grid-column: 1 / -1; }
.ms-box-foot { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ms-btn-light {
  height: 38px; padding: 0 16px; border-radius: 8px; border: none; background: var(--on-dark); color: var(--shell-ink);
  font-weight: 700; font-size: 13px;
}
.ms-btn-light[disabled] { opacity: 0.6; }

/* The cards: Your actions, Sessions, Shared files */
.ms-card { border-radius: 16px; border: 1px solid var(--shell-ink-10); overflow: hidden; min-width: 0; background: var(--shell-bg); }
.ms-card-head { padding: 22px 26px; border-bottom: 1px solid var(--shell-ink-08); }
.ms-card-head--split { display: flex; align-items: baseline; justify-content: space-between; gap: 16px; }
.ms-card-head--files { padding: 20px 24px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ms-card-titles { display: flex; flex-direction: column; gap: 3px; }
.ms-h2 { margin: 0; font-size: 21px; font-weight: 800; }
.ms-h2--small { font-size: 19px; }
.ms-card-sub { font-size: 13px; color: var(--shell-ink-60); }
.ms-count { font-size: 14px; font-weight: 700; white-space: nowrap; }
.ms-card-foot { margin: 0; padding: 14px 26px 18px; font-size: 14px; line-height: 1.6; color: var(--shell-ink-62); }
.ms-card-foot--files { padding: 14px 24px 18px; font-size: 13px; line-height: 1.55; color: var(--shell-ink-60); }
.ms-card-msg { margin: 0; padding: 12px 26px 0; font-size: 14px; font-weight: 600; line-height: 1.5; }
.ms-card-msg--top { padding: 12px 24px; border-bottom: 1px solid var(--shell-ink-06); }
.ms-card-none { margin: 0; padding: 16px 24px; font-size: 14px; color: var(--shell-ink-60); border-bottom: 1px solid var(--shell-ink-06); }

/* Your actions */
.ms-action { display: flex; gap: 14px; align-items: flex-start; padding: 15px 26px; border-bottom: 1px solid var(--shell-ink-06); cursor: pointer; }
.ms-action input { width: 19px; height: 19px; margin: 2px 3px 3px 4px; accent-color: var(--shell-ink); flex-shrink: 0; }
.ms-action-text { font-size: 15px; line-height: 1.5; color: var(--shell-ink); }
.ms-action--done .ms-action-text { color: var(--shell-ink-60); text-decoration: line-through; }
.ms-add { display: flex; gap: 8px; padding: 14px 26px; background: var(--shell-ink-02); }
.ms-add input {
  height: 38px; flex: 1; min-width: 0; padding: 0 12px; border-radius: 8px; border: 1px solid var(--shell-ink-20);
  background: var(--shell-bg); font-size: 14px;
}
.ms-add .ms-btn--small { height: 38px; padding: 0 14px; }

/* Sessions */
.ms-session { border-bottom: 1px solid var(--shell-ink-06); }
.ms-session-row { display: flex; gap: 22px; align-items: center; padding: 18px 26px; }
.ms-date {
  width: 56px; flex-shrink: 0; display: flex; flex-direction: column; align-items: center; padding: 8px 0;
  border-radius: 10px; background: var(--shell-ink-04);
}
.ms-date-small { font-size: 11px; font-weight: 700; letter-spacing: 0.08em; color: var(--shell-ink-60); }
.ms-date-day { font-size: 22px; font-weight: 800; line-height: 1.1; }
.ms-session-text { flex: 1; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.ms-session-title { font-size: 17px; font-weight: 800; }
.ms-session-length { font-size: 14px; color: var(--shell-ink-62); }
.ms-session-where { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: var(--shell-ink-62); }
.ms-session-where--watched { color: var(--shell-ink); }
.ms-session-buttons { display: flex; gap: 22px; flex-shrink: 0; }
.ms-session-buttons .ms-btn { align-self: center; }
.ms-panel {
  margin: 0 26px 18px 104px; padding: 16px 18px; border-radius: 10px; background: var(--shell-ink-03);
  display: flex; flex-direction: column; gap: 6px;
}
.ms-panel--player { padding: 0; background: transparent; max-width: 872px; }
.ms-panel--player > .ms-panel-text { padding: 16px 18px; border-radius: 10px; background: var(--shell-ink-03); }
.ms-panel-label { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--shell-ink-60); }
.ms-panel-text { margin: 0; font-size: 15px; line-height: 1.65; }
.ms-after { padding: 18px 26px 22px; background: var(--shell-ink-02); display: flex; flex-direction: column; gap: 12px; }
.ms-after-h { font-size: 14px; font-weight: 800; }
.ms-after-fields { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr); gap: 12px; }
.ms-after input {
  height: 40px; padding: 0 12px; border-radius: 8px; border: 1px solid var(--shell-ink-20); background: var(--shell-bg); font-size: 14px; min-width: 0;
}
.ms-after textarea {
  height: 80px; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--shell-ink-20); background: var(--shell-bg);
  font-size: 14px; line-height: 1.5; resize: none; min-width: 0;
}
.ms-after-foot { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ms-after-foot .ms-btn--small { align-self: center; }

/* Shared files */
.ms-file { display: flex; align-items: center; gap: 12px; padding: 14px 24px; border-bottom: 1px solid var(--shell-ink-06); }
.ms-file-icon {
  width: 34px; height: 34px; border-radius: 8px; background: var(--shell-ink-05); color: var(--shell-ink);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ms-file-text { flex: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ms-file-name { font-size: 14px; font-weight: 700; overflow-wrap: anywhere; }
.ms-file-meta { font-size: 12px; color: var(--shell-ink-60); }
.ms-file-msg { font-size: 13px; font-weight: 600; line-height: 1.5; margin-top: 4px; }
.ms-file-dl {
  border: none; background: transparent; padding: 6px 0; font-size: 13px; font-weight: 700;
  text-decoration: underline; color: var(--shell-ink); flex-shrink: 0;
}
.ms-file-input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }

/* Ask Adam */
.ms-ask {
  padding: 22px 24px; border-radius: 16px; border: 1px solid var(--shell-ink-10);
  display: flex; flex-direction: column; gap: 12px; min-width: 0;
}
.ms-ask-line { font-size: 14px; line-height: 1.55; color: var(--shell-ink-66); }
.ms-ask textarea {
  height: 90px; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--shell-ink-20);
  font-size: 14px; line-height: 1.5; resize: none;
}
.ms-ask-sent { font-size: 14px; font-weight: 700; }
.ms-ask-msg { font-size: 14px; font-weight: 600; line-height: 1.5; }
.ms-ask-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }

/* Ending the space, Adam only */
.ms-end {
  padding: 18px 26px 22px; border-radius: 16px; border: 1px dashed var(--shell-ink-20); background: var(--shell-ink-02);
  display: flex; flex-direction: column; gap: 10px;
}
.ms-end-h { margin: 0; font-size: 14px; font-weight: 800; }
.ms-end-line { margin: 0; font-size: 14px; line-height: 1.6; color: var(--shell-ink-66); max-width: 760px; }
.ms-end-confirm { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.ms-end-ask { font-size: 14px; font-weight: 700; }
.ms-end-buttons { display: flex; gap: 10px; flex-wrap: wrap; }
.ms-end-msg { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-66); }
.ms-end-msg--bad { color: var(--shell-ink); font-weight: 600; }

/* The spaces, for Adam: on /mentorship with none picked, and under /admin */
.ms-spaces { list-style: none; margin: 0; padding: 0; border-radius: 16px; border: 1px solid var(--shell-ink-10); overflow: hidden; max-width: 760px; }
.ms-spaces[aria-busy='true'] { min-height: 80px; border-color: transparent; }
.ms-space { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 16px 22px; border-bottom: 1px solid var(--shell-ink-06); }
.ms-space:last-child { border-bottom: none; }
.ms-space-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ms-space-name { font-size: 16px; font-weight: 700; }
.ms-space-meta { font-size: 13px; color: var(--shell-ink-60); }
.ms-space-link { font-size: 14px; font-weight: 700; color: var(--shell-ink); flex-shrink: 0; }
.ms-spaces-none { margin: 0; font-size: 16px; line-height: 1.6; color: var(--shell-ink-66); }

/* Under /admin, in the shell */
.ms-admin { display: flex; flex-direction: column; gap: 16px; margin-top: 24px; max-width: 760px; }
.ms-admin-h2 { margin: 0; font-size: 24px; font-weight: 800; }
.ms-open { display: flex; flex-direction: column; gap: 14px; margin-top: 16px; padding: 24px; border-radius: 16px; border: 1px dashed var(--shell-ink-20); }
.ms-open-h { margin: 0; font-size: 19px; font-weight: 800; }
.ms-open-line { margin: 0; font-size: 15px; line-height: 1.55; color: var(--shell-ink-66); }
.ms-open-field { display: flex; flex-direction: column; gap: 6px; font-size: 14px; font-weight: 600; }
.ms-open-field input {
  height: 44px; padding: 0 12px; border-radius: 10px; border: 1px solid var(--shell-ink-20); font: inherit;
  font-size: 15px; font-weight: 500; color: var(--shell-ink); background: var(--shell-bg);
}
.ms-open-hint { font-size: 13px; font-weight: 500; line-height: 1.5; color: var(--shell-ink-60); }
.ms-open .sh-actions-row { margin: 0; }
.ms-open-msg { margin: 0; font-size: 15px; line-height: 1.55; }
.ms-open-msg a { color: var(--shell-ink); font-weight: 700; }
.ms-open-msg--bad { font-weight: 600; }

/* Between a laptop and a phone: the next session's boxes in 2 columns */
@media (max-width: 1099px) {
  .ms-next-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .ms-session-row { gap: 18px; }
  .ms-session-buttons { gap: 10px; }
}

/* A phone (no board: PhoneLibrary's and PhoneWeek's patterns) */
@media (max-width: 760px) {
  .ms { gap: 20px; }
  .ms-bar { margin: -22px -16px 2px; padding: 12px 16px; flex-direction: column; align-items: flex-start; gap: 8px; }
  .ms-bar-text { font-size: 13px; align-items: flex-start; }
  .ms-bar-dot { margin-top: 5px; }
  .ms-eyebrow { font-size: 12px; }
  .ms-h1 { font-size: 30px; }
  .ms-row { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .ms-next, .ms-book { padding: 22px 20px; }
  .ms-next-when { font-size: 26px; }
  .ms-chip, .ms-cal, .ms-join { padding: 0 12px; font-size: 13px; }
  .ms-book .ms-btn { align-self: stretch; }
  .ms-card-head, .ms-card-head--files { padding: 18px 16px; }
  .ms-h2 { font-size: 19px; }
  .ms-card-foot, .ms-card-foot--files { padding: 14px 16px 16px; }
  .ms-card-msg { padding: 12px 16px 0; }
  .ms-card-msg--top, .ms-card-none { padding: 12px 16px; }
  .ms-action { padding: 14px 16px; gap: 12px; }
  .ms-add { padding: 12px 16px; flex-wrap: wrap; }
  .ms-add input { flex-basis: 100%; }
  .ms-session-row { flex-wrap: wrap; padding: 16px; gap: 12px 14px; }
  .ms-date { width: 48px; padding: 6px 0; }
  .ms-date-day { font-size: 20px; }
  .ms-session-buttons { width: 100%; gap: 10px; }
  .ms-session-buttons > * { flex: 1; justify-content: center; }
  .ms-panel { margin: 0 16px 16px; }
  .ms-after { padding: 16px; }
  .ms-after-fields { grid-template-columns: minmax(0, 1fr); }
  .ms-file { padding: 14px 16px; }
  .ms-ask { padding: 20px 16px; }
  .ms-ask .ms-btn--small { align-self: stretch; }
  .ms-end { padding: 16px; }
  .ms-end-confirm { flex-direction: column; align-items: flex-start; }
  .ms-space { padding: 14px 16px; flex-direction: column; align-items: flex-start; gap: 8px; }
  .ms-open { padding: 20px 16px; }
}
